import { MobileBannerWrapper } from './styles';
const MobileBanner = () => {
  return <MobileBannerWrapper></MobileBannerWrapper>;
};

export default MobileBanner;
